export const DAYS = {
  0: "sunday",
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
};

export const TERMS_OF_USE_URL =
  "https://laringroup.notion.site/Terms-and-Conditions-f35f3d14a58947019314c292fd6b3f36";

export const PRIVACY_POLICY_URL =
  "https://laringroup.notion.site/Privacy-Policy-52865abbb604424a98c384506dca5530";


export const RICH_TEXT_EDIT_KEY = 'z1buvk1oox3gqenfyaw94rk0lzm9m3pwmjy1i3uny96ztyeq';